export const COMMUNICATION_PATHS = {
  SEND_PUSH: {
    _: 'communication/send-push',
  },
  HISTORY: {
    _: 'communication/history',
  },
} as const;
